export const tableSortingOrder = {
  asc: "asc",
  desc: "desc",
};
